import React, { Component } from "react";
import ReactDOM from "react-dom";
import axios from "axios"; 
import { getErrorsMessage, getSuccessMessage } from "../utils.js";
import { LangContext } from "../LangContext.jsx";
import CancelSubscription from "./CancelSubscription";

class PaymentInformation extends Component {
    static contextType = LangContext;
    constructor(props) {
        super();
        const defaultLang = this.context || { get: () => {} }; // Asume que lang tiene un método 'get'
        this.state = {
            companyBillingInfo: [],
            cards: []
        };
    } 

    getCompanyBillingInfo = () => {
        console.log(this.props.person_id);
        axios.get("/api/company-billing-info/"+this.props.person_id).then((res) => {
            this.setState({ companyBillingInfo: res.data });
        }); 
    }

    getPaymentMethods = () => {
        axios.get("/api/zoho/payment-methods").then((res) => {
            console.log(res.data);
            this.setState({ cards: res.data.data });
        }).catch((error) => {
            console.error('Error fetching payment methods:', error);
        });
    }
    setPrimaryPaymentMethod = (paymentMethodId) => { 
        axios.post(`/api/zoho/payment-methods/${paymentMethodId}/mark-as-primary`)
        .then((response) => { 
            console.log(response.data.success)
            if (response.data.success == true) {
                Swal.fire({
                    text: "Método de pago actualizado correctamente",
                    icon: "success",
                    buttonsStyling: false,
                    confirmButtonText: 'Aceptar',
                    customClass: {
                        confirmButton: "btn font-weight-bold btn-primary"
                    }
                });
                this.getPaymentMethods(); // Vuelve a cargar los métodos de pago
            } else {
                // Si la respuesta no es exitosa, muestra el error
                Swal.fire({
                    text: response.data.message || "Hubo un error al actualizar el método de pago.",
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: lang.get('messages.aceptar'),
                    customClass: {
                        confirmButton: "btn font-weight-bold btn-primary"
                    }
                });
            }
        })
    };
    
    componentDidMount() {
        console.log(this.props.person_id);
        if (this.props.person_id) {
            this.getCompanyBillingInfo();
        }
        this.getPaymentMethods();
    }

    render() { 
        return (
            <> 
            <div className="card card-custom mt-5">
                <div className="card-header py-3">
                    <div className="card-title align-items-start flex-column"> 
                        <h3 className="card-label font-weight-bolder text-dark">Información de Pago</h3> 
                    </div> 
                </div> 
                <div className="row card-body">
                    <div className="col-md-6  "> 
                            <div className="col-md-12  card-custom card p-10">
                            <label className="font-weight-bolder font-size-h5 text-dark-75 text-hover-primary">Datos de facturación</label>
                                <div className="text-muted">
                                    <p>
                                        {this.state.companyBillingInfo.fiscal_name} <br></br>  
                                        {this.state.companyBillingInfo.rfc}  <br></br>  
                                        {this.state.companyBillingInfo.address1} </p>
                                </div>
                                <CancelSubscription subscriptionId={this.props.subscriptionId} subscription={this.props.subscription} subscriptionEndDate={this.props.subscriptionEndDate} personVenvers={this.props.personVenvers} inlineTrigger={true} />
                            </div>  
                    </div>
                    <div className="col-md-6  ">
                    <div className="col-md-12  card-custom card p-10">
                        <label className="font-weight-bolder font-size-h5 text-dark-75 text-hover-primary">Metodo de pago</label>
                        <table className="table"> 
                            <tbody>
                                {this.state.cards.map((card, index) => (
                                <tr key={index}>
                                    <td>
                                        {card.brand === 'visa' && (
                                            <svg xmlns="http://www.w3.org/2000/svg" width="20px" height="20px" viewBox="0 -140 780 780" enableBackground="new 0 0 780 500" version="1.1" xmlSpace="preserve">
                                                <path d="M40,0h700c22.092,0,40,17.909,40,40v420c0,22.092-17.908,40-40,40H40c-22.091,0-40-17.908-40-40V40C0,17.909,17.909,0,40,0z" fill="#0E4595"/>
                                                <path d="m293.2 348.73l33.361-195.76h53.36l-33.385 195.76h-53.336zm246.11-191.54c-10.57-3.966-27.137-8.222-47.822-8.222-52.725 0-89.865 26.55-90.18 64.603-0.299 28.13 26.514 43.822 46.752 53.186 20.771 9.595 27.752 15.714 27.654 24.283-0.131 13.121-16.586 19.116-31.922 19.116-21.357 0-32.703-2.967-50.227-10.276l-6.876-3.11-7.489 43.823c12.463 5.464 35.51 10.198 59.438 10.443 56.09 0 92.5-26.246 92.916-66.882 0.199-22.269-14.016-39.216-44.801-53.188-18.65-9.055-30.072-15.099-29.951-24.268 0-8.137 9.668-16.839 30.557-16.839 17.449-0.27 30.09 3.535 39.938 7.5l4.781 2.26 7.232-42.429m137.31-4.223h-41.232c-12.773 0-22.332 3.487-27.941 16.234l-79.244 179.4h56.031s9.16-24.123 11.232-29.418c6.125 0 60.555 0.084 68.338 0.084 1.596 6.853 6.49 29.334 6.49 29.334h49.514l-43.188-195.64zm-65.418 126.41c4.412-11.279 21.26-54.723 21.26-54.723-0.316 0.522 4.379-11.334 7.074-18.684l3.605 16.879s10.219 46.729 12.354 56.528h-44.293zm-363.3-126.41l-52.24 133.5-5.567-27.13c-9.725-31.273-40.025-65.155-73.898-82.118l47.766 171.2 56.456-0.064 84.004-195.39h-56.521" fill="#ffffff"/>
                                                <path d="m146.92 152.96h-86.041l-0.681 4.073c66.938 16.204 111.23 55.363 129.62 102.41l-18.71-89.96c-3.23-12.395-12.597-16.094-24.186-16.527" fill="#F2AE14"/>
                                            </svg> 
                                        )}
                                        {card.brand === 'mastercard' && (
                                            <svg width="20px" height="20px" viewBox="0 -9 58 58" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                <rect x="0.5" y="0.5" width="57" height="39" rx="3.5" fill="white" stroke="#F3F3F3"/>
                                                <path d="M34.3102 28.9765H23.9591V10.5122H34.3102V28.9765Z" fill="#FF5F00"/>
                                                <path d="M24.6223 19.7429C24.6223 15.9973 26.3891 12.6608 29.1406 10.5107C27.1285 8.93843 24.5892 7.99998 21.8294 7.99998C15.2961 7.99998 10 13.2574 10 19.7429C10 26.2283 15.2961 31.4857 21.8294 31.4857C24.5892 31.4857 27.1285 30.5473 29.1406 28.975C26.3891 26.8249 24.6223 23.4884 24.6223 19.7429" fill="#EB001B"/>
                                                <path d="M48.2706 19.7429C48.2706 26.2283 42.9745 31.4857 36.4412 31.4857C33.6814 31.4857 31.1421 30.5473 29.1293 28.975C31.8815 26.8249 33.6483 23.4884 33.6483 19.7429C33.6483 15.9973 31.8815 12.6608 29.1293 10.5107C31.1421 8.93843 33.6814 7.99998 36.4412 7.99998C42.9745 7.99998 48.2706 13.2574 48.2706 19.7429" fill="#F79E1B"/>
                                            </svg> 
                                        )} 
                                    </td>
                                    <td>{card.brand}</td>
                                    <td>**** {card.last_four_digits}</td>
                                    <td>
                                        {card.is_primary ? (
                                            <span className="badge badge-primary">Predeterminada</span>
                                        ) : (
                                            <span></span>
                                        )}
                                    </td>
                                    <td>{card.expiry_month}/{card.expiry_year}  </td>
                                    <td>    
                                    <div className="dropdown dropdown-inline">
                                        <a href="#"  className="btn btn-fixed-height btn-secondary font-weight-bolder font-size-sm p-1 "   data-toggle="dropdown" aria-haspopup="true"  aria-expanded="false"  >
                                            <i class="flaticon-more text-primary pr-0 "  ></i>   
                                        </a>
                                        <div className="dropdown-menu dropdown-menu-lg dropdown-menu-right p-0 m-0 rounded-lg"  style={{ background: "#F0E9FF" }}  >
                                            <ul className="navi navi-hover">
                                                <li className="navi-item">
                                                    <a href="#" className="navi-link py-4" onClick={(e) => { 
                                                        e.preventDefault(); 
                                                        this.setPrimaryPaymentMethod(card.card_id); 
                                                    }}>
                                                    <span className="navi-icon mr-5 text-center">
                                                        <span className="flaticon-star text-primary icon-md"></span>
                                                    </span>
                                                    <span className="navi-text text-secondary">Hacer predeterminado</span>
                                                    <span className="navi-icon pull-right">
                                                        <button className="btn btn-icon btn-light btn-xs bg-white">
                                                            <i className="flaticon2-right-arrow text-primary icon-sm"></i>
                                                        </button>
                                                    </span>
                                                    </a>
                                                </li> 
                                            </ul>
                                        </div>
                                    </div>
                                    
                                    </td>
                                </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                    </div>
                </div>
            </div>
            </>
        );
    }
}

export default PaymentInformation;

if (document.getElementById("PaymentInformation")) {
    ReactDOM.render(<PaymentInformation />, document.getElementById("PaymentInformation"));
}
